import { Injectable } from '@angular/core';
import { D2CUser } from '@telus/d2c-core';
import { AuthService } from '@telus/d2c-core/auth';
import { forkJoin, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppInit {
  constructor(private authService: AuthService, private d2cUser: D2CUser) {}

  initApp() {
    return new Promise(async (resolve) => {
      this.authService.runInitialLoginSequence().then(() => {
        this.authService.isAuthenticated$.subscribe({
          error: (e) => {
            console.error('AppInit: isAuthenticated$ error:', e);
            resolve(true);
          },
          next: (_) => {
            const isLoggedIn = this.authService.hasValidToken();
            if (isLoggedIn) {
              // [DPD-2758] Determine if we should use CPMS or legacy Reproster
              const isPartnerUser = !this.d2cUser.isTelusMember();
              const shouldFetchCPMSUserInfo =
                environment.enableStriker && isPartnerUser;
              const requests: [Observable<boolean>, Observable<any>] = [
                this.authService.configurePrivileges(),
                shouldFetchCPMSUserInfo
                  ? this.d2cUser.getCPMSUserInformation()
                  : this.d2cUser.getVendorUserInformation(),
              ];

              forkJoin(requests)
                .pipe(take(1))
                .subscribe(
                  (results: any[]) => {
                    // [DPD-2758] Handle CPMS context result
                    if (shouldFetchCPMSUserInfo) {
                      if (results[1]) {
                        sessionStorage.setItem(
                          'cpmsInfo',
                          JSON.stringify(results[1])
                        );
                      }
                      resolve(results[0]);
                    } else {
                      // Legacy Reproster flow (unchanged)
                      if (results[1]) {
                        sessionStorage.setItem(
                          'vendorInfo',
                          JSON.stringify(results[1])
                        );
                        this.d2cUser
                          .getVendorUserGroupsByVAN()
                          .then((groups) => {
                            if (groups) {
                              sessionStorage.setItem(
                                'vendorGroupsOfVAN',
                                JSON.stringify(groups)
                              );
                              resolve(results[0]);
                            } else {
                              resolve(results[0]);
                            }
                          })
                          .catch((e) => {
                            console.error(
                              'AppInit: Error getting vendor groups:',
                              e
                            );
                            sessionStorage.setItem(
                              'initError',
                              JSON.stringify(e)
                            );
                          });
                      } else if (results[1] === null) {
                        if (!this.d2cUser.isTelusMember()) {
                          sessionStorage.setItem(
                            'initError',
                            JSON.stringify('')
                          );
                        }
                        resolve(results[0]);
                      }
                    }
                  },
                  (e) => {
                    console.error('AppInit: forkJoin error:', e);
                    sessionStorage.setItem('initError', JSON.stringify(e));
                    resolve(true);
                  }
                );
            } else {
              return resolve(true);
            }
          },
        });
      });
    });
  }
}
